<template>
  <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }">
    <template #title>
      <a-row type="flex" align="middle">
        <h6 class="font-semibold m-0">Danh sách bài viết</h6>
        <router-link :to="{ name: 'CreateArticle' }">
          <a-button type="primary" class="ml-20">Thêm mới</a-button>
        </router-link>
      </a-row>
    </template>
    <a-table :loading="callingAPI" :columns="columns" :data-source="dataSource" :pagination="pagination"
      @change="handleTableChangePage" rowKey="id">
      <template slot="publish_at" slot-scope="row">
        {{ row.publish_at | formatDate }}
      </template>
      <template slot="image" slot-scope="row">
        <img v-if="row.thumbnail" :src="`${row.thumbnail}`" alt="" class="preview-image-table" />
      </template>
      <template slot="status" slot-scope="row">
        <a-switch v-model="row.status" @change="handleUpdate(row)" />
      </template>
      <template slot="action" slot-scope="row">
        <a-space>
          <router-link :to="{ name: 'UpdateArticle', params: { id: row.id } }">
            <a-button shape="circle" icon="edit" size="small" />
          </router-link>
          <a-popconfirm placement="topRight" ok-text="Xóa" cancel-text="Hủy" @confirm="removeArticle(row)">
            <template slot="title">
              <p>Xóa {{ row.title }} ??</p>
            </template>
            <a-button type="danger" shape="circle" icon="delete" size="small" />
          </a-popconfirm>
        </a-space>
      </template>
    </a-table>
  </a-card>
</template>

<script>
import ENDPOINT from '@/config/endpoint'
import { fetchArticle, updateArticle, removeArticle } from '@/services/landing-page/news/article'
import dayjs from 'dayjs'
import { replaceUrlResource } from '@/utils/common'

export default {
  name: 'ManageNewsArticle',
  data() {
    return {
      backendUrl: ENDPOINT.BACKEND_URL,
      callingAPI: false,

      pagination: {
        total: 0,
        pageSize: 10,
        current: 1,
      },

      dataSource: [],
      columns: [
        {
          title: 'Tiêu đề',
          dataIndex: 'title',
          scopedSlots: { customRender: 'title' },
          class: 'font-semibold',
          width: 250,
        },
        {
          title: 'Xuất bản',
          scopedSlots: { customRender: 'publish_at' },
          class: 'font-semibold',
          width: 150,
        },
        {
          title: 'Thumbnail',
          scopedSlots: { customRender: 'image' },
          width: 150,
        },
        {
          title: 'Hiển thị',
          scopedSlots: { customRender: 'status' },
          width: 100,
          align: 'center'
        },
        {
          scopedSlots: { customRender: 'action' },
          width: 50,
        },
      ],
    }
  },
  async beforeMount() {
    await this.loadData()
  },
  methods: {
    async loadData() {
      try {
        this.callingAPI = true
        const params = {
          per_page: this.pagination.pageSize,
          page: this.pagination.current
        };
        const response = await fetchArticle(params)
        this.dataSource = response.data.data.map((d) => ({
          ...d,
          status: d.status === 1,
          thumbnail: replaceUrlResource(d.thumbnail)
        }))
        this.pagination.total = response.data.total
        this.callingAPI = false
      } catch (error) {
        this.callingAPI = false
      }
    },

    async handleTableChangePage(pagination) {
      this.pagination.current = pagination.current;
      await this.loadData();
    },

    async handleUpdate(row) {
      try {
        const formData = new FormData()
        formData.append("title", row.title)
        formData.append("description", row.description)
        formData.append("content", row.content || '')
        formData.append("status",  row.status ? 1 : 2)
        formData.append("hot_news", row.hot_news ? 1 : 2)
        formData.append("category_id", row.category_id)
        formData.append("publish_at", dayjs(row.publish_at).format('DD/MM/YYYY'))
        formData.append("thumbnail", row.thumbnail)
        formData.append("_method", "PUT");
        const response = await updateArticle(row.id, formData)
        if (response.status === 1) {
          this.$notification.success({
            message: 'Thành công',
            description: 'Cập nhật trạng thái hiển thị thành công.',
          });
        } else {
          this.$notification.error({
            message: 'Thất bại',
            description: 'Cập nhật trạng thái hiển thị thất bại.',
          });
        }
      } catch (error) {
        console.log(error)
      }
    },

    async removeArticle(row) {
      try {
        this.callingAPI = true
        const response = await removeArticle(row.id)
        if (response.status === 1) {
          this.$notification.success({
            message: 'Thành công',
            description: 'Xóa thành công',
          });
        } else {
          this.$notification.error({
            message: 'Thất bại',
            description: 'Xóa thất bại',
          });
        }
        this.pagination.current = this.dataSource?.length > 1 ? this.pagination.current : Math.max(this.pagination.current - 1, 1)
        await this.loadData()
        this.callingAPI = false
      } catch (error) {
        this.callingAPI = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>